import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

let io

export const onClientEntry = () => {
  if (typeof document === "undefined") return
  document.documentElement.classList.add("js")
}

export const onRouteUpdate = () => {
  if (typeof document === "undefined") return

  // 前回の監視を破棄（これが安定）
  if (io) io.disconnect()

  const targets = document.querySelectorAll(
    ".fadeInUp, .slideInLeft, .slideInRight, .liftUp, .liftUpHeavy, .revealBox"
  )

  io = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        entry.target.classList.add("on")
        obs.unobserve(entry.target)
      })
    },
    { threshold: 0.1 }
  )

  targets.forEach(el => io.observe(el))
}